// app/javascript/controllers/email_subscription_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["submitButton", "input", "error"]

  connect() {
    this.inputTarget.placeholder = 'Enter your email address'
  }

  async submit(event) {
    event.preventDefault()
    this.clearError()
    this.storeOriginalButtonState()
    this.showLoading()
    this.disableFields()

    try {
      const tokenRes = await fetch("/csrf/token", {
        method: "POST",
        credentials: "same-origin",
        headers: { "Accept": "text/plain" }
      })
      if (!tokenRes.ok) throw new Error("Failed to fetch CSRF token")
      const csrfToken = await tokenRes.text()

      const response = await fetch(this.element.action, {
        method: this.element.method,
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": csrfToken
        },
        body: JSON.stringify({"_": this.inputTarget.value})
      })

      if (response.ok) {
        this.onSuccess()
      } else {
        const body = await response.json()
        this.onError(body.error)
      }
    } catch (err) {
      this.onError("An unexpected error occurred.")
    }

    return false
  }

  storeOriginalButtonState() {
    this._originalHtml = this.submitButtonTarget.innerHTML
    // fix width so spinner doesn’t shrink button
    const w = this.submitButtonTarget.offsetWidth
    this.submitButtonTarget.style.width = `${w}px`
  }

  showLoading() {
    const spinner = `<div class="loading-animation small"><div></div><div></div><div></div><div></div></div>`
    this.submitButtonTarget.innerHTML = spinner
  }

  disableFields() {
    this.submitButtonTarget.disabled = true
    this.inputTargets.forEach(i => i.disabled = true)
  }

  enableFields() {
    this.submitButtonTarget.disabled = false
    this.inputTargets.forEach(i => i.disabled = false)
  }

  clearError() {
    this.element.classList.remove("has-error")
    this.errorTarget.classList.remove("d-block")
    this.errorTarget.classList.add("d-none")
    this.errorTarget.textContent = ""
  }

  onSuccess() {
    this.submitButtonTarget.classList.remove("btn-primary")
    this.submitButtonTarget.classList.add("btn-success")
    this.submitButtonTarget.disabled = false
    this.submitButtonTarget.type = "button"
    this.submitButtonTarget.innerHTML = `<i class="fas fa-check"></i>`
  }

  onError(message) {
    this.enableFields()
    this.submitButtonTarget.innerHTML = this._originalHtml
    this.submitButtonTarget.style.width = "auto"

    if (message) {
      this.element.classList.add("has-error")
      this.errorTarget.textContent = message
      this.errorTarget.classList.add("d-block")
      this.errorTarget.classList.remove("d-none")
    }
  }
}
